//引入
// import cmpTitle from '@cmp/cmp-title'
import cmpBread from '@cmp/bread'
import cmpBanner from '@cmp/cmp-banner'
import cmpTab from '@cmp/tab'
import cmpSubTab from '@cmp/tab/sub-tab'
import cmpMyPagination from '@cmp/my-pagination'
import cmpDetail from '@cmp/cmp-detail'

function plugins(Vue) {
  //注册
  // Vue.component('cmpTitle', cmpTitle) //第一个参数:组件名称,第二个参数:要注册的组件
  Vue.component('cmpBread', cmpBread)
  Vue.component('cmpBanner', cmpBanner)
  Vue.component('cmpTab', cmpTab)
  Vue.component('cmpSubTab', cmpSubTab)
  Vue.component('cmpMyPagination', cmpMyPagination)
  Vue.component('cmpDetail', cmpDetail)
}
export default plugins